export default class BaseService {
    get host () {
        return `http${process.env.VUE_APP_API_SECURE === 'true' ? 's' : ''}://${process.env.VUE_APP_API_HOST}`
    }
}
